// src/hooks/useOwnerMedia.ts — async loader for the owner media summary.
import { useEffect, useState } from 'react';
import { ownerService } from '@/core/services/ownerService';
import type { MediaSummary } from '@/core/models';

export interface OwnerMediaHook {
  data: MediaSummary | null;
  loading: boolean;
  error: string | null;
}

export function useOwnerMedia(): OwnerMediaHook {
  const [data, setData] = useState<MediaSummary | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional loader flag
    setLoading(true);
    ownerService
      .getMediaSummary()
      .then((d) => { if (alive) { setData(d); setError(null); } })
      .catch(() => { if (alive) setError('Failed to load media summary'); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);
  return { data, loading, error };
}
